import html2canvas from "html2canvas";

/**
 * Captura un elemento DOM como imagen PNG y comparte o descarga.
 * @param {HTMLElement} element
 * @param {string} filename
 * @returns {Promise<'shared'|'downloaded'>}
 */
export async function shareOrDownloadInvoiceImage(element, filename) {
  if (!element) {
    throw new Error("No hay contenido para capturar");
  }

  const canvas = await html2canvas(element, {
    scale: 2,
    backgroundColor: "#ffffff",
    logging: false,
    useCORS: true,
    allowTaint: true,
  });

  const blob = await new Promise((resolve, reject) => {
    canvas.toBlob((b) => (b ? resolve(b) : reject(new Error("Error al crear imagen"))), "image/png", 1);
  });

  const file = new File([blob], filename, { type: "image/png" });

  if (navigator.share && navigator.canShare?.({ files: [file] })) {
    try {
      await navigator.share({
        files: [file],
        title: filename.replace(".png", ""),
      });
      return "shared";
    } catch (err) {
      if (err?.name === "AbortError") {
        throw err;
      }
    }
  }

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
  return "downloaded";
}
